import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function DocumentCode({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M7 9L8.5 7.5L7 6M6 17V15M19.5 21H5C3.89 21 3 20.1 3 19V18C3 17.44 3.44 17 4 17H17C17.55 17 18 17.44 18 18V19.5C18 20.32 18.67 21 19.5 21ZM19.5 21C20.32 21 21 20.32 21 19.5V5C21 3.89 20.1 3 19 3H15M5.5 3H9.5C10.8807 3 12 4.11929 12 5.5V9.5C12 10.8807 10.8807 12 9.5 12H5.5C4.11929 12 3 10.8807 3 9.5V5.5C3 4.11929 4.11929 3 5.5 3Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default DocumentCode;